import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AppCmsUrlsInitializationService } from 'src/app/services/app-cms-urls-initialization.service';
import { ApplicationInitializationService } from 'src/app/services/application-initialization.service';
import { CmsContentService } from 'src/app/services/cms-content.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-tabby-modal',
  templateUrl: './tabby-modal.component.html',
  styleUrls: ['./tabby-modal.component.scss']
})
export class TabbyModalComponent implements OnInit {
  currentLanguage: string;
  data:any;
  ENV;
  @Input() ShowMethods;
  @Input() totalPayNow:any;
  URL;
  paymentMonths :any[]=[];
  constructor(
    private modalController: ModalController,private APPCMSIS: AppCmsUrlsInitializationService,private APPIS: ApplicationInitializationService,private UTS: UtilitiesService,private CCS:CmsContentService
  ) { }

  ngOnInit(): void {
    this.paymentMonths = ['4','6','12'];
    this.URL = this.ShowMethods ? 'BNPL_LEARN_MORE' : 'BNPL_TREMS_CONDITIONS';
    this.ENV = localStorage.getItem('ENV');
    let CMS_URLS = this.APPCMSIS.appInitializer.CMS_URLS; 
    let CMS_URL = null;
    let url = null;
    if (CMS_URLS && CMS_URLS.length > 0){
      CMS_URL = CMS_URLS.find((c) => c?.cmsUrlCode == this.URL);
      url = this.APPIS.environmentConfig?.CMS_URL_NEW_FRAGMENTPATH + CMS_URL?.cmsUrlEn;
    }
    if (this.UTS.getLocaleLanguage() == 'ar'){
      url = this.APPIS.environmentConfig?.CMS_URL_NEW_FRAGMENTPATH + CMS_URL?.cmsUrlAr;
    }
    this.CCS.newFragemnetContentService(url).subscribe(
      (result: any) => {
        if(this.URL == 'BNPL_LEARN_MORE'){
          this.data = result?.data?.nwtConsumerGenericModulesByPath?.item?.consumerMainSection;
        }else{
          this.data = result?.data?.nwtConsumerPopupMainSectionByPath?.item?.popupSection;
        }
      },
      (error) => {
      }
    );
  }

  dismiss() {
    this.modalController.dismiss({
      dismissed: true,
    });
  }

  setStatusLabelColor(tile: any) {
    var style;
    if (tile?.length && tile[0]?.includes('limited-stock')) {
      style = {
        'background-color': '#FFF083'
      }
    }
    else if (tile?.length && tile[0]?.includes('bestseller')) {
      style = {
        'background-color': '#DBCFD2'
      }
    }
    else if (tile?.length && tile[0]?.includes('discount')) {
      style = {
        'background-color': '#E00800'
      }
    }
    else if (tile?.length && tile[0]?.includes('main-usp')) {
      style = {
        'background-color': '#F7EEDA'
      }
    }
    else if (tile?.length && tile[0]?.includes('online-exclusive')) {
      style = {
        'background-color': '#EBEBE3'
      }
    }
    else if (tile?.length && tile[0]?.includes('sold-out')) {
      style = {
        'background-color': '#F3F3ED'
      }
    }
    else if (tile?.length && tile[0]?.includes('gold')) {
      style = {
        'background-image': 'linear-gradient(to left,' + '#93703D,#F8D279' + ')',
      }
    }
    else if (tile?.length && tile[0]?.includes('bronze')) {
      style = {
        'background-color': '#9A7552'
      }
    }
    else if (tile?.length && tile[0]?.includes('silver')) {
      style = {
        'background-image': 'linear-gradient(to left,' + '#B6B6B6, #E7E7E7' + ')',
      }
    }
    else if (tile?.length && tile[0]?.includes('sale')) {
      style = {
        'background-color': '#ED6B66'
      }
    }
    else if (tile?.length && tile[0]?.includes('black-grey')) {
      style = {
        'background-image': 'linear-gradient(to left,' + '#151515,#4B4A4B' + ')',
      }
    }
    else if (tile?.length && tile[0]?.includes('dark-red')) {
      style = {
        'background-image': 'linear-gradient(to left,' + '#0A0A0A,#E00800' + ')',
      }
    }
    else if (tile?.length && tile[0]?.includes('storm')) {
      style = {
        'background-image': 'linear-gradient(to left,' + '#0A0A0A,#E9EDF' + ')',
      }
    }
    else if (tile?.length && tile[0]?.includes('bright')) {
      style = {
        'background-image': 'linear-gradient(to left,' + '#E00800,ED6B66' + ')',
      }
    }
    else if (tile?.length && tile[0]?.includes('white')) {
      style = {
        'background-color': '#FFFFFF'
      }
    }
    else if (tile?.length && tile[0]?.includes('black')) {
      style = {
        'background-color': '#000000'
      }
    }
    else if (tile?.length && tile[0]?.includes('beige-60')) {
      style = {
        'background-color': '#F0F0EA'
      }
    }
    else if (tile?.length && tile[0]?.includes('primary-etisalat-black-100')) {
      style = {
        'background-color': '#0A0A0A'
      }
    }
    else if (tile?.length && tile[0]?.includes('primary-etisalat-black-80')) {
      style = {
        'background-color': ' #3B3B3B'
      }
    }
    else if (tile?.length && tile[0]?.includes('primary-etisalat-black-60')) {
      style = {
        'background-color': '#6C6C6C'
      }
    }
    else if (tile?.length && tile[0]?.includes('primary-etisalat-black-40')) {
      style = {
        'background-color': '#9D9D9D'
      }
    }
    else if (tile?.length && tile[0]?.includes('eand-red-60')) {
      style = {
        'background-color': '#E00800'
      }
    }
    else if (tile?.length && tile[0]?.includes('eand-red-80')) {
      style = {
        'background-color': '#E73933'
      }
    }
    else if (tile?.length && tile[0]?.includes('eand-red-100')) {
      style = {
        'background-color': '#E00800'
      }
    }
    return style;
  }

}
